<template>
  <div
    v-if="$router.currentRoute.path !== '/' && paidCount && totalCount"
    class="text-center mt-3 usage">
    <div class="usage-progress">
      <div
        :style="{width: `${Math.ceil(paidCount * 100 / totalCount) }%`}"
        class="current-progress "
        :class="paidCount < totalCount? 'primary': 'error'"
      >
        <span>{{ Math.floor(paidCount) }}</span>
      </div>
    </div>
    <p class="font-weight-bold mb-0 mt-1">{{ totalCount-Math.floor(parseInt(paidCount)) }}  is left out of {{ totalCount }} {{usageModel === '24hr-Conversation'? 'CV': 'AU'}} </p>
  </div>
</template>

<script>
  export default {
    name: "consBar",
    data () {
      return {
        paidCount: 0,
        totalCount: 0,
        usageModel: ''
      }
    },
    mounted() {
        this.getAccountData()
    },
    methods: {
      getAccountData() {
        this.$http_licence.get(`accounts/${this.$store.state.settings.settings.licence_id}/show`)
        .then(res=>{
          this.usageModel = res.data.data.packages[0].consumption_type
          let totalQuery = ''
          let currentQuery = ''
         if (this.usageModel === '24hr-Conversation') {
           currentQuery = {"measures":["Conversations.countPaid"],"timeDimensions":[{"dimension":"Conversations.createdAt"}],"order":{},"dimensions":[],"filters":[{"member":"Conversations.packageType","operator":"equals","values":["Paid"]},{"member":"UserInformations.licenceId","operator":"equals","values":[this.$store.state.settings.settings.licence_id]}],"limit":7500,"segments":[]}
           totalQuery = {"measures":["Packages.totalSessions"],"timeDimensions":[{"dimension":"Packages.createdAt"}],"order":{},"dimensions":[],"filters":[{"member":"Packages.consumptionType","operator":"equals","values":["24hr-Conversation"]},{"member":"Packages.paymentType","operator":"equals","values":["Paid"]},{"member":"UserInformations.licenceId","operator":"equals","values":[this.$store.state.settings.settings.licence_id]}],"limit":7500,"segments":[]}
         } else {
           currentQuery = {"measures":["UserInformations.countPaid"],"timeDimensions":[{"dimension":"UserInformations.createdAt"}],"order":{},"dimensions":[],"filters":[{"member":"UserInformations.packageType","operator":"equals","values":["Paid"]},{"member":"UserInformations.licenceId","operator":"equals","values":[this.$store.state.settings.settings.licence_id]}],"limit":7500,"segments":[]}
           totalQuery = {"measures":["Packages.totalSessions"],"timeDimensions":[{"dimension":"Packages.createdAt"}],"order":{},"dimensions":[],"filters":[{"member":"Packages.consumptionType","operator":"equals","values":["ActiveUser"]},{"member":"Packages.paymentType","operator":"equals","values":["Paid"]},{"member":"UserInformations.licenceId","operator":"equals","values":[this.$store.state.settings.settings.licence_id]}],"limit":7500,"segments":[]}
         }
          this.getSessionUsage(currentQuery)
          this.getSessionsTotal(totalQuery)
        })
        .catch(err=>{

        })
      },
      getSessionUsage(cubeQuery) {
        this.$http_cube.get(`cubejs-api/v1/load?query=${JSON.stringify(cubeQuery)}&queryType=multi`)
        .then(res=>{
          if (this.usageModel === '24hr-Conversation') {
            this.paidCount = res.data.results[0].data[0]['Conversations.countPaid']
          } else {
            this.paidCount = res.data.results[0].data[0]['UserInformations.countPaid']
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
      getSessionsTotal(cubeQuery) {
        this.$http_cube.get(`cubejs-api/v1/load?query=${JSON.stringify(cubeQuery)}&queryType=multi`)
          .then(res=>{
            this.totalCount = res.data.results[0].data[0]['Packages.totalSessions']
          })
          .catch(err=>{
            console.log(err)
          })
      }
    }
  }
</script>

<style scoped>
  .usage-progress {
    width: 300px;
    height: 18px;
    background: #97edff;
    border-radius: 50px;
    overflow: hidden;
  }
  .current-progress {
    height: 100%;
    border-radius: 50px;
  }
  .current-progress span {
    color: white;
    font-size: 12px;
    line-height: 15px;
    display: none;
    transition: all 0.5s;
  }

  .current-progress:hover span {
    display: block;
  }
  .usage {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
